import React from 'react';
import { Receipt } from '../../../../../../../types/clientReceipts';
import { formatCurrency, formatDate } from '../../../../../../../utils/formatters';
import './ReviewCard.scss';

interface ReviewCardProps {
  receipt: Receipt;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ receipt }) => {
  const { review } = receipt;

  if (!review || !review.rating) return null;

  // Calculate average rating
  const avgRating = (
    (review.rating.amabilidad.rating + 
     review.rating.sabor.rating + 
     review.rating.experiencia.rating) / 3
  ).toFixed(1);

  const renderStars = (rating: number) => {
    return (
      <div className="rating-stars">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`star ${star <= rating ? 'filled' : ''}`}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="review-card">
      <div className="review-header">
        <div className="review-info">
          <h3>Recibo #{receipt.receipt_number}</h3>
          <p className="review-date">{formatDate(receipt.timestamp)}</p>
        </div>
        <div className="review-rating-summary">
          <div className="avg-rating">{avgRating}</div>
          {renderStars(parseFloat(avgRating))}
        </div>
      </div>

      <div className="review-content">
        {/* Amabilidad */}
        <div className="review-section">
          <div className="section-header">
            <span className="section-title">Atención y Amabilidad</span>
            {renderStars(review.rating.amabilidad.rating)}
          </div>
          {review.rating.amabilidad.comment && (
            <p className="section-comment">{review.rating.amabilidad.comment}</p>
          )}
        </div>

        {/* Sabor */}
        <div className="review-section">
          <div className="section-header">
            <span className="section-title">Sabor y Calidad</span>
            {renderStars(review.rating.sabor.rating)}
          </div>
          {review.rating.sabor.comment && (
            <p className="section-comment">{review.rating.sabor.comment}</p>
          )}
          {review.rating.sabor.favorite && (
            <div className="favorite-item">
              <span className="favorite-label">⭐ Favorito:</span>
              <span className="favorite-name">{review.rating.sabor.favorite.item_name}</span>
            </div>
          )}
          {review.rating.sabor.worst && (
            <div className="worst-item">
              <span className="worst-label">👎 No cumplió expectativas:</span>
              <span className="worst-name">{review.rating.sabor.worst.item_name}</span>
            </div>
          )}
        </div>

        {/* Experiencia */}
        <div className="review-section">
          <div className="section-header">
            <span className="section-title">Experiencia General</span>
            {renderStars(review.rating.experiencia.rating)}
          </div>
          {review.rating.experiencia.comment && (
            <p className="section-comment">{review.rating.experiencia.comment}</p>
          )}
        </div>

        {/* Total amount */}
        <div className="review-amount">
          <span className="amount-label">Total del recibo</span>
          <span className="amount-value">{formatCurrency(receipt.total_payed)}</span>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
